import { Injectable } from "@angular/core";
import { BulkFormMoveToFolderRequest, FormListResponse, FormResponse, FormUpsertRequest, GetFormSubmissionsResponse, GetSharedEntitiesResponse, SuccessResponse } from "@me-fit-mono/typings";
import { environment } from "src/environments/environment";
import { StateManagerService } from "./state-manager.service";

@Injectable({
  providedIn: "root"
})
export class FormsStateService {

  private API_FORMS = `${environment.API_ENDPOINT}/forms`;

  constructor(private $state: StateManagerService) {}

  upsert = this.$state.createState<FormUpsertRequest, FormResponse>({
    httpMethod: "post",
    path: `${this.API_FORMS}/upsert`,
    onNewResponse: () => this.findAll.call(),
  });

  duplicate = this.$state.createState<void, FormResponse, { id: string }>({
    httpMethod: "post",
    path: `${this.API_FORMS}/duplicate/:id`,
    onNewResponse: () => this.findAll.call(),
  });

  findAll = this.$state.createState<void, FormListResponse>({
    httpMethod: "get",
    path: this.API_FORMS,
  });

  getForm = this.$state.createState<string, FormResponse, { id: string }>({
    httpMethod: "get",
    path: `${this.API_FORMS}/:id`,
  });

  deleteForm = this.$state.createState<void, SuccessResponse, { id: string }>({
    httpMethod: "delete",
    path: `${this.API_FORMS}/:id`,
    onNewResponse: () => this.findAll.call(),
  });

  /**
   * Will return customers and groups the form is shared with
   */
  getFormSharedEntities = this.$state.createState<void, GetSharedEntitiesResponse>({
    httpMethod: "get",
    path: `${this.API_FORMS}/:id/shared-entities`,
  });

  /**
   * Deletes a form submission by its id
   */
  deleteSubmission = this.$state.createState<void, SuccessResponse, { id: string }>({
    httpMethod: "delete",
    path: `${this.API_FORMS}/submission/:id`,
  });

  /**
   * Gets all submissions for a form across all users in the organization
   */
  getFormSubmissions = this.$state.createState<void, GetFormSubmissionsResponse, { id: string }>({
    httpMethod: "get",
    path: `${this.API_FORMS}/:id/submissions`,
  });

  /**
   * Bulk move forms to a folder
   */
  bulkMoveToFolder = this.$state.createState<BulkFormMoveToFolderRequest, SuccessResponse>({
    httpMethod: "patch",
    path: `${this.API_FORMS}/bulk-move-to-folder`,
  });
}
